/** 读取用户选的 CSV / 文本文件。Excel（中文 Windows）另存的 CSV 是 GBK 编码，按 UTF-8 读不出来时退回 GB18030 */
export async function readTextFile(file: File): Promise<string> {
  const buf = await file.arrayBuffer();
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(buf);
  } catch {
    return new TextDecoder('gb18030').decode(buf);
  }
}
